  if (!window.customElements.get('capponi-delivery-estimate')) {
    class CapponiDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        try {
          this.render();
        } catch (e) {
          /* si algo falla queda el texto de reserva, nunca una fecha inventada */
        }
        /* El cajón se re-renderiza en el sitio al añadir al carrito (morph de la
           sección) y eso vuelve a pintar el texto de reserva sin reconectar este
           elemento. Si el hueco pierde la fecha calculada (el <strong>), se
           recalcula. El propio render pone el <strong>, así que no hay bucle. */
        if (!this._obs) {
          this._obs = new MutationObserver(() => {
            const target = this.querySelector('[data-delivery-range]');
            if (target && !target.querySelector('strong')) {
              try {
                this.render();
              } catch (e) {
                /* queda el texto de reserva */
              }
            }
          });
          this._obs.observe(this, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        if (this._obs) {
          this._obs.disconnect();
          this._obs = null;
        }
      }

      get config() {
        const d = this.dataset;
        const base = {
          cutoffHour: parseInt(d.cutoffHour, 10),
          minBefore: parseInt(d.minBefore, 10),
          maxBefore: parseInt(d.maxBefore, 10),
          minAfter: parseInt(d.minAfter, 10),
          maxAfter: parseInt(d.maxAfter, 10),
        };
        let overrides = {};
        if (d.overrides) {
          try {
            overrides = JSON.parse(d.overrides);
          } catch (e) {
            overrides = {};
          }
        }
        const o = overrides[d.collection] || {};
        return {
          cutoffHour: o.cutoffHour ?? base.cutoffHour,
          minBefore: o.minDaysBefore ?? base.minBefore,
          maxBefore: o.maxDaysBefore ?? base.maxBefore,
          minAfter: o.minDaysAfter ?? base.minAfter,
          maxAfter: o.maxDaysAfter ?? base.maxAfter,
        };
      }

      /* Partes de fecha en la zona de la tienda sin reparsear cadenas:
         mas fiable que new Date(string) en los navegadores in-app de iOS. */
      zonedParts() {
        const tz = this.dataset.timezone || 'Europe/Madrid';
        const fmt = new Intl.DateTimeFormat('en-CA', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          hourCycle: 'h23',
        });
        const parts = {};
        for (const p of fmt.formatToParts(new Date())) parts[p.type] = p.value;
        return {
          year: parseInt(parts.year, 10),
          month: parseInt(parts.month, 10),
          day: parseInt(parts.day, 10),
          hour: parseInt(parts.hour, 10),
        };
      }

      get holidays() {
        return (this.dataset.holidays || '')
          .split(/[,\n]/)
          .map((v) => v.trim())
          .filter((v) => /^\d{4}-\d{2}-\d{2}$/.test(v));
      }

      static key(date) {
        const m = String(date.getUTCMonth() + 1).padStart(2, '0');
        const d = String(date.getUTCDate()).padStart(2, '0');
        return date.getUTCFullYear() + '-' + m + '-' + d;
      }

      isBusinessDay(date, holidays) {
        const dow = date.getUTCDay();
        return dow !== 0 && dow !== 6 && !holidays.includes(CapponiDeliveryEstimate.key(date));
      }

      addBusinessDays(from, days, holidays) {
        const result = new Date(from.getTime());
        let added = 0;
        let guard = 0;
        while (added < days && guard < 400) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (this.isBusinessDay(result, holidays)) added++;
          guard++;
        }
        return result;
      }

      format(date) {
        const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
        return days[date.getUTCDay()] + ' ' + date.getUTCDate();
      }

      render() {
        const target = this.querySelector('[data-delivery-range]');
        if (!target) return;

        const cfg = this.config;
        const now = this.zonedParts();
        const holidays = this.holidays;
        const today = new Date(Date.UTC(now.year, now.month - 1, now.day));

        const beforeCutoff = now.hour < cfg.cutoffHour;
        const minDays = beforeCutoff ? cfg.minBefore : cfg.minAfter;
        const maxDays = beforeCutoff ? cfg.maxBefore : cfg.maxAfter;

        const start = this.addBusinessDays(today, minDays, holidays);
        const end = this.addBusinessDays(today, maxDays, holidays);

        if (minDays === maxDays) {
          target.innerHTML = '<strong>el ' + this.format(start) + '</strong>';
        } else {
          target.innerHTML = '<strong>entre ' + this.format(start) + ' y ' + this.format(end) + '</strong>';
        }
      }
    }

    window.customElements.define('capponi-delivery-estimate', CapponiDeliveryEstimate);
  }
